import { userAuthStore } from "@/business/auth/infrastructure/store/userAuthStore";

export const isAuthenticated = {
  execute(): boolean {
    return userAuthStore().isAuth.value;
  },
};
